import React from 'react';
import TextAlignment from '../../../components/TextAlignment';
import renderContentfulBody from '../richTextRenderer/renderContentfulBody';
import getThemeClass from '../../../utils/getThemeClass';
import styles from './TextTile.module.css';
import Cutouts from '../../../components/Cutouts';

/**
 * @param {FF.ContentfulTextTileProps} props
 * */
export default function TextTile({
  alignment,
  backgroundColor,
  body,
  className = '',
  cutouts,
}) {
  return (
    <Cutouts cutouts={cutouts}>
      <TextAlignment
        alignment={alignment}
        className={`${getThemeClass(backgroundColor)} ${className}`}
      >
        <div className={styles.wrapper}>{renderContentfulBody(body)}</div>
      </TextAlignment>
    </Cutouts>
  );
}
